/* eslint-disable prettier/prettier */
import React from 'react'
import { Cell } from 'rsuite-table'

type AmountCellProps = {
  rowData?: { [key: string]: number | string }
  dataKey: string
}

const defaultProps = {
  rowData: undefined
}

const AmountCell: React.FC<AmountCellProps> = ({ rowData, dataKey, ...props }) => {
  const amount = rowData?.[dataKey]

  return (
    <Cell {...props}>
      {amount ? `₹ ${amount}` : '₹ 0'}
    </Cell>
  )
}

AmountCell.defaultProps = defaultProps

export default AmountCell
